require('./axios');
require('./multiselect');
require('./vuelidate');
require('./swiper');
require('./moment');
require('./aos');
require('./vueformulate');
require('./vue-editor');
require('./sweetalert');
require('./gmap');
